import { FormProvider, useForm, type FieldErrors } from 'react-hook-form'

import { Input } from '@components/shared/Input'
import { RowBox } from '@components/shared/RowBox'
import { Select } from '@components/shared/Select'
import { useUsers } from '@pages/Users/context'
import { Button } from '@components/shared/Button'
import { FilterIcon } from '@assets/svgs/FilterIcon'
import { CloseIcon } from '@assets/svgs/CloseIcon'
import { initialFormValues } from './form/initialFormValues'

import type { ClFiltersProps } from './types'
import type { ClFormProps } from './form/types'

import * as S from './styles'

export const ClFilters = ({ onFilter }: ClFiltersProps) => {
  const { clByUserCodeData, isClByUserCodeLoading } = useUsers()

  const methods = useForm<ClFormProps>({
    defaultValues: initialFormValues
  })

  const onError = (errors: FieldErrors<ClFormProps>) => console.log({ errors })

  const onSubmit = (formData: ClFormProps) => onFilter(formData)

  return (
    <FormProvider {...methods}>
      <RowBox columns={5} marginTop={24} marginBottom={24}>
        <Input
          name="profitCenter"
          label="Centro de Lucro"
          placeholder="ID,Código, Nome"
          disabled={isClByUserCodeLoading}
        />

        <Select
          name="businessUnit"
          label="BU"
          options={
            clByUserCodeData?.availableFilters?.businessUnits.map((businessUnit) => ({
              label: businessUnit,
              value: businessUnit
            })) || []
          }
          disabled={isClByUserCodeLoading}
        />

        <Select
          name="segment"
          label="Portfólio"
          options={
            clByUserCodeData?.availableFilters?.segments.map((segment) => ({
              label: segment,
              value: segment
            })) || []
          }
          disabled={isClByUserCodeLoading}
        />
        <Select
          name="directorate"
          label="Diretoria"
          options={
            clByUserCodeData?.availableFilters?.boardsOfDirectors.map((directorate) => ({
              label: directorate,
              value: directorate
            })) || []
          }
          disabled={isClByUserCodeLoading}
        />

        <S.FilterButtons>
          <Button
            width="100%"
            colorType="outlineBlue"
            rightIcon={<FilterIcon />}
            onClick={() => methods.handleSubmit(onSubmit, onError)()}
            disabled={isClByUserCodeLoading}
          >
            Filtrar
          </Button>

          <Button
            width="100%"
            colorType="outlineBlue"
            rightIcon={<CloseIcon />}
            onClick={() => {
              methods.reset()
              onFilter(initialFormValues)
            }}
            disabled={isClByUserCodeLoading}
          >
            Limpar
          </Button>
        </S.FilterButtons>
      </RowBox>
    </FormProvider>
  )
}
